import { render } from "./PriceAccuracyWidget.vue?vue&type=template&id=1c747ad2&scoped=true"
import script from "./PriceAccuracyWidget.vue?vue&type=script&lang=js"
export * from "./PriceAccuracyWidget.vue?vue&type=script&lang=js"

import "./PriceAccuracyWidget.vue?vue&type=style&index=0&id=1c747ad2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c747ad2"]])

export default __exports__